// TODO - remove becouse of legacy

import { Selector } from 'reselect'
import { Moment } from 'moment-timezone'
import { ReduxState } from 'store/createRootReducer'

export const dateListSelector: Selector<ReduxState, Moment> = (state) => state.adSpends.dateList
export default dateListSelector
